import OrderCargoOrderAbandonedListRequest, {
  OrderCargoOrderAbandonedListRequestOrder,
} from "../../../../../api/raily/order/cargo-order/abandoned/list/order-cargo-order-abandoned-list.request";
import AbandonedCargoOrder from "../../../../../types/abandoned-cargo-order";
import paginationService from "../../../../../utils/pagination/pagination.service";
import OrderCargoOrderAbandonedListParams from "./order-cargo-order-abandoned-list-params";

const createOrder = (
  order: AbandonedCargoOrder | null,
): OrderCargoOrderAbandonedListRequestOrder | null => {
  switch (order) {
    case AbandonedCargoOrder.CREATED_AT_ASC:
      return OrderCargoOrderAbandonedListRequestOrder.CREATED_AT_ASC;
    case AbandonedCargoOrder.CREATED_AT_DESC:
      return OrderCargoOrderAbandonedListRequestOrder.CREATED_AT_DESC;
    case AbandonedCargoOrder.HUMAN_ID_ASC:
      return OrderCargoOrderAbandonedListRequestOrder.HUMAN_ID_ASC;
    case AbandonedCargoOrder.HUMAN_ID_DESC:
      return OrderCargoOrderAbandonedListRequestOrder.HUMAN_ID_DESC;
    case AbandonedCargoOrder.MODIFIED_AT_ASC:
      return OrderCargoOrderAbandonedListRequestOrder.MODIFIED_AT_ASC;
    case AbandonedCargoOrder.MODIFIED_AT_DESC:
      return OrderCargoOrderAbandonedListRequestOrder.MODIFIED_AT_DESC;
    default:
      return null;
  }
};

const create = (
  params: OrderCargoOrderAbandonedListParams,
): OrderCargoOrderAbandonedListRequest => {
  return {
    limit: params.pageSize,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    order: createOrder(params.order),
    address: params.address,
    client: params.client,
    creationEnd: params.creationEnd,
    creationStart: params.creationStart,
    dispatch: params.dispatch,
    endAddress: params.endAddress,
    externalId: params.externalId,
    humanId: params.humanId,
    midAddress: params.midAddress,
    passenger: params.passenger,
    publicStatus: params.publicStatus,
    startAddress: params.startAddress,
    startTimeSince: params.startTimeSince,
    startTimeTo: params.startTimeTo,
  };
};

const orderCargoOrderAbandonedListParamsFactory = { create };

export default orderCargoOrderAbandonedListParamsFactory;
